import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'en',
  messages: {
    es: {
      // Login
      mensaje_login: 'Acceso al Sistema',
      ingresar: 'Ingresar',
      mensaje_olvidar_contrasena: '¿Olvidaste tu contraseña?',
      mensaje_link_restablecer1: 'Da click',
      mensaje_link_restablecer2: 'aquí',
      mensaje_link_restablecer3: 'para restablecerla.',
      msg_password_reset: 'Ingrese su E-Mail y a continuación le enviaremos una contraseña temporal.',
      msg_password_reset_done1: 'Le hemos enviado una contraseña temporal por E-Mail.',
      msg_password_reset_done2: '¡Deberías recibir el correo en breve!',
      Bienvenido: 'Bienvenido',
      agregar: 'Agregar',
      quitar: 'Quitar',
      modificar: 'Modificar',
      cerrar: 'Cerrar',
      Buscar: 'Buscar',
      ningun_resultado_1: 'La búsqueda de',
      ningun_resultado_2: 'no tiene coincidencias',
      prep_de: 'de',
      filas_por_pagina: 'Filas por Página',
      todos: 'Todos',
      region: 'es-MX',
      Ayuda: 'Ayuda',
      Administrador: 'Administrador',
      Vigilante: 'Vigilante',
      SuperAdministrador: 'SuperAdministrador',
      user: 'Usuario',
      // Menú Empleado
      Historial_Invitaciones_Enviadas: 'Historial de Invitaciones Enviadas',
      Historial_Invitaciones_Recibidas: 'Historial de Invitaciones Recibidas',
      Historial_Accesos: 'Historial de Accesos',
      Historial_Accesos_Trabajadores: 'Historial de Accesos Trabajadores',
      Historial_Accesos_Biometrico: 'Historial de Accesos por Biométrico',
      Historial: 'Historial',
      Historial_avanzado: 'Historial Avanzado',
      // Menú Vigilante
      bitacora: 'Bitácora',
      entradas_salidas: 'Acceso/Salida',
      check_in_time: 'Hora de Entrada',
      check_out_time: 'Hora de Salida',
      acceso_sin_codigo: 'Acceso sin Código',
      historial_accesos_sin_codigo: 'Historial de Accesos sin Código',
      // Menú Administrador
      Invitaciones: 'Invitaciones',
      Accesos: 'Accesos',
      firma_salida: 'Firmar Pase de Salida',
      firmado: 'Firmado',
      no_firmado: 'No Firmado',
      firmar: 'Firmar',
      mensaje_pase_salida_firmado: 'Pase de salida firmado con éxito.',
      no_registros_pase_salida: 'No hay registros de acceso.',
      mensaje_pase_salida: 'Personas dentro de la Empresa',
      Casetas: 'Casetas',
      Vigilantes: 'Vigilantes',
      boton_emergencia: 'Botón de Emergencia',
      // Empleados
      Empleados: 'Empleados',
      AnadirEmpleado: 'Añadir Empleado',
      mensaje_empleado_alta: 'Empleado dado de Alta Correctamente.',
      mensaje_empleado_modificado: 'Empleado Modificado Correctamente.',
      Area: 'Área',
      Nombre: 'Nombre(s)',
      Apellido: 'Apellido(s)',
      Invitacion: 'Invitación',
      puede_enviar: 'Puede enviar invitaciones',
      rented_house: 'Casa rentada',
      renting_house: 'Active la casilla si la persona está rentando la casa.',
      extension: 'Extensión',
      ine_frente: 'Imagen frente Identificación',
      foto_ine: 'Identificación Oficial con Foto (INE, Licencia de Conducir)',
      ine_atras: 'Imagen atrás Identificación',
      celular: 'Celular',
      password: 'Contraseña',
      current_password: 'Contraseña Actual',
      new_password: 'Contraseña Nueva',
      password_new_confirm: 'Confirmar Contraseña Nueva',
      msg_cambio_password: 'Contraseña cambiada Correctamente.',
      password_confirm: 'Confirmar contraseña',
      Activo: 'Activo',
      // Casetas
      anadir_caseta: 'Añadir Caseta',
      mensaje_caseta_alta: 'Caseta Agregado Correctamente',
      mensaje_caseta_modificada: 'Caseta Modificada Correctamente.',
      mensaje_caseta_eliminada: 'Caseta Eliminada Correctamente.',
      // Vigilantes
      anadir_vigilante: 'Añadir Vigilante',
      mensaje_vigilante_alta: 'Vigilante Agregado Correctamente.',
      mensaje_vigilante_modificado: 'Vigilante Modificado Correctamente.',
      mensaje_vigilante_eliminado: 'Vigilante Eliminado Correctamente.',
      mostrar_info_invit: 'Mostrar información de la invitación',
      info_invitation: 'INFORMACIÓN DE LA INVITACIÓN',
      info_residente: 'INFORMACIÓN DEL SOCIO',
      info_invitado: 'INFORMACIÓN DEL INVITADO',
      info_worker: 'INFORMACIÓN DEL TRABAJADOR',
      info_anfitrion: 'INFORMACIÓN DEL ANFITRIÓN',
      info_access: 'INFORMACIÓN DE ACCESO',
      datos_coche: 'Datos del automóvil',
      guardar: 'Guardar',
      acceso: 'Acceso',
      registrar_salida: 'Registrar salida',
      form_salida: 'Formulario Salida',
      mensaje_alta_acceso_in: 'Acceso Registrado Correctamente.',
      mensaje_alta_acceso_out: 'Salida Registrada Correctamente.',
      mensaje_qr_no_valido: 'Código QR, no válido.',
      mensaje_qr_multiple: 'Algo salío mal, varios registros con mismo Código QR.',
      mensaje_qr_no_valido_fraccionamiento: 'Esta invitación no corresponde a este Club.',
      mensaje_acceso_completo: 'Ya se completó el Acceso con la Invitación Correspondiente.',
      mensaje_alta_acceso_without: 'Acceso Registrado Correctamente.',
      // Residentes
      anadir_residente: 'Añadir Dependiente',
      mensaje_residente_alta: 'Dependiente Agregado Correctamente.',
      mensaje_residente_modificado: 'Dependiente Modificado Correctamente.',
      mensaje_residente_eliminado: 'Dependiente Eliminado Correctamente.',
      // Trajadores
      worker: 'Trabajador',
      workers: 'Trabajadores',
      add_worker: 'Añadir Trabajador',
      msg_worker_added: 'Trabajador Agregado Correctamente.',
      msg_worker_update: 'Trabajador Modificado Correctamente.',
      msg_worker_deleted: 'Trabajador Eliminado Correctamente.',
      // Invitados
      mensaje_invitado_alta: 'Invitado Agregado Correctamente.',
      // Invitación
      Empleado: 'Empleado',
      fecha_hora: 'Fecha y Hora de la Invitación',
      fecha_inv: 'Fecha de la Invitación',
      fecha_expiracion: 'Fecha de Expiración',
      fecha_inicial: 'Fecha Inicial',
      creation_date: 'Fecha de creación',
      finish_date: 'Fecha de finalización',
      hora_inv: 'Hora de la Invitación',
      Asunto: 'Asunto',
      placeholder_asunto: 'Escribe el Asunto de la Invitación',
      mensaje_equipo: 'Equipo de seguridad requerido:',
      equipo_seguridad: 'Equipo',
      mensaje_vehiculo: '¿Acceso con vehículo?',
      enviar_codigo: 'Enviar Código',
      Notas: 'Notas',
      placeholder_notas: 'Escribe Notas extras para la Invitación',
      Si: 'Si',
      invitación_referido: 'Invitación Referido',
      ininvitación_normal: 'Invitación',
      mensaje_invitacion_alta: 'Invitación Enviada Correctamente.',
      // Empresas
      Empresas: 'Empresas',
      AnadirFraccionamiento: 'Añadir Club',
      telefono: 'Teléfono',
      logotipo: 'Logotipo',
      pagina_web: 'Página Web',
      clasificacion: 'Clasificación',
      latitud: 'Latitud',
      longitud: 'Longitud',
      url_mapa: 'URL del Mapa',
      vigencia: 'Vigencia',
      Parque: 'Parque',
      mensaje_empresa_alta: 'Club dada de Alta Correctamente.',
      mensaje_empresa_modificado: 'Club Modificado Correctamente.',
      // Fraccionamientos
      Fraccionamientos: 'Clubes',
      Fraccionamiento: 'Club',
      AnadirFraccionamientos: 'Añadir Club',
      nombre: 'Nombre',
      full_name: 'Nombre Completo',
      direccion: 'Dirección',
      mensaje_parque_alta: 'Parque dado de alta Correctamente.',
      mensaje_parque_modificado: 'Parque Modificado Correctamente.',
      // Jefes de Departamento
      department_manager: 'Jefe de Departamento',
      add_department_manager: 'Añadir Jefe de Departamento',
      msg_department_manage_added: 'Jefe de Departamento Agregado Correctamente.',
      msg_department_manage_updated: 'jefe de Departamento Modificado Correctamente.',
      // Roles y Permisos
      roles_permisos: 'Roles y Permisos',
      rol_department_manager: 'Gestor de Departamentos',
      rol_starter: 'Starter',
      rol_associates: 'Gestión de Asociados',
      rol_account_statements: 'Estados de Cuenta',
      rol_sports: 'Módulo Deportes',
      rol_employees: 'Gestión de Empleados',
      rol_golf_admin: 'Administrador de Golf',
      // Modal Jefe de Departamento
      edit_department_manager: 'Editar Jefe de Departamento',
      datos_personales: 'Datos Personales',
      documentos: 'Documentos',
      permisos: 'Permisos',
      credenciales: 'Credenciales de Acceso',
      cambiar_password: 'Cambiar Contraseña',
      // Administradores
      Administradores: 'Administradores',
      anadir_administrador: 'Añadir Administrador',
      anadir_main_resident: 'Añadir Titular',
      Empresa: 'Empresa',
      mensaje_administrador_alta: 'Administrador dado de Alta Correctamente.',
      mensaje_administrador_modificado: 'Administrador Modificado Correctamente.',
      mensaje_administrador_eliminada: 'Administrador Eliminado Correctamente.',
      mensaje_mainresident_alta: 'Titular dado de Alta Correctamente.',
      mensaje_mainresident_modificado: 'Titular Modificado Correctamente.',
      mensaje_mainresident_eliminado: 'Titular Eliminado Correctamente.',
      mensaje_users_alta: 'Usuarios Validados Correctamente.',
      mensaje_users_baja: 'Usuarios Eliminados Correctamente.',
      mensaje_accessnocode_baja: 'Registro(s) Eliminado(s) Correctamente.',
      mensaje_email_sent: 'Email enviado correctamente.',
      mensaje_users_activados: 'Usuarios Activados Correctamente.',
      mensaje_users_desactivados: 'Usuarios Desactivados Correctamente.',
      // Relacionar Casas para estado de cuenta
      msg_relate_home_add: 'Casa Asociada Correctamente.',
      msg_lot_add: 'Lote Agregado Correctamente.',
      msg_relate_home_update: 'Registro Modificada Correctamente.',
      msg_relate_home_delete: 'Registro Eliminada Correctamente.',
      // Directorio
      add_directory: 'Añadir',
      mensaje_directory_alta: 'Registro Agregado Correctamente.',
      mensaje_directory_modificado: 'Registro Modificado Correctamente.',
      mensaje_directory_eliminada: 'Registro Eliminado Correctamente.',
      // Áreas
      Areas: 'Áreas',
      add_area: 'Añadir Área ',
      msg_area_added: 'Área Agregada Correctamente.',
      msg_area_updated: 'Área Modificada Correctamente.',
      mensaje_casas_importadas: 'Número de acciones importadas Correctamente.',
      account_statements_imported_correctly: 'Estados de cuenta importados Correctamente.',
      anadir_casa: 'Añadir número de acción ',
      mensaje_casa_alta: 'Número de acción Agregado Correctamente.',
      mensaje_casa_modificado: 'Número de acción Modificada Correctamente.',
      mensaje_casa_eliminada: 'Número de acción Eliminada Correctamente.',
      // Paqueteria
      mensaje_paqueteria_alta: 'Paquete agregado correctamente.',
      mensaje_paqueteria_entregado: 'Paquete(s) entregado(s) correctamente.',
      // Notices
      Notices: 'Comunicados',
      add_notice: 'Añadir Comunicado',
      msg_added_notice: 'Comunicado agregada correctamente.',
      msg_notice_updated: 'Comunicado modificada correctamente.',
      msg_notice_deleted: 'Comunicado eliminada correctamente.',
      // Financial Statements
      financial_statements: 'Estados Financieros',
      add_financial_statements: 'Añadir Estado Financiero',
      msg_added_financial_statement: 'Estado Financiero agregada correctamente.',
      msg_financial_statement_updated: 'Estado Financiero modificada correctamente.',
      msg_financial_statement_deleted: 'Estado Financiero eliminada correctamente.',
      // Generic Notices
      msg_generic_notice_send: 'Su solicitud ha sido enviada correctamente.',
      msg_generic_notice_approval: 'Comunicado aprobado correctamente.',
      msg_generic_notice_reject: 'Comunicado rechazado correctamente.',
      msg_notice_user_deleted: 'Comunicado para ese socio eliminado correctamente.',
      msg_notice_user_added: 'Comunicado para ese socio enviado correctamente.',
      msg_notice_user_sent: 'Comunicado enviado correctamente.',
      // Reports
      Reports: 'Reportes',
      add_report: 'Añadir Reporte',
      msg_added_report: 'Reporte agregada correctamente.',
      msg_report_updated: 'Reporte modificada correctamente.',
      msg_report_deleted: 'Reporte eliminada correctamente.',
      // Deportes
      sports: 'Deportes',
      sport: 'Deporte',
      add_sport: 'Agregar Deporte',
      select_color: 'Seleccione un color',
      sports_schedules: 'Horarios deporte',
      choose_sport: 'Seleccione un deporte',
      choose_day: 'Seleccione un día',
      msg_sport_added: 'Deporte agregado correctamente.',
      msg_sport_updated: 'Deporte modificado correctamente.',
      add_sport_schedule: 'Añadir Horario',
      schedule: 'Horario',
      msg_schedule_added: 'Horario agregada correctamente.',
      msg_schedule_updated: 'Horario modificada correctamente.',
      msg_schedule_deleted: 'Horario eliminada correctamente.',
      // Contactos
      contactos: 'Contactos',
      anadir_contacto: 'Añadir Contacto',
      mensaje_contacto_alta: 'Contacto Agregado Correctamente.',
      mensaje_contacto_modificado: 'Contacto Modificado Correctamente.',
      // Grupos
      grupos: 'Grupos',
      anadir_grupo: 'Añadir Grupo',
      mensaje_grupo_alta: 'Grupo Agregado Correctamente.',
      mensaje_grupo_modificado: 'Grupo Modificado Correctamente.',
      mensaje_grupo_delete: 'Grupo Eliminado Correctamente',
      eliminar: 'Eliminar',
      // ContactosXGrupo
      contactosXgrupo: 'Contactos Por Grupo',
      mensaje_contactoXgrupo_alta: 'Contacto Agregado Correctamente al Grupo.',
      mensaje_contactoXgrupo_delete: 'Contacto Eliminado del Grupo Correctamente.',
      // Invitaciones
      Filtrar: 'Filtrar',
      select_fecha: 'Seleccionar fecha:',
      mostrando_inv_dia: 'Mostrando invitaciones del día:',
      mostrando_historial_dia: 'Mostrando Historial del día:',
      Fecha: 'Fecha',
      Hora: 'Hora',
      Visitante: 'Visitante',
      Anfitrion: 'Anfitrión',
      hora_acceso: 'Hora de Acceso',
      hora_salida: 'Hora de Salida',
      opening_time: 'Hora de apertura',
      closing_time: 'Hora de cierre',
      Tipo: 'Tipo',
      weekday: 'Día de la semana',
      no_registros_invit: 'No hay registros de invitaciones para ese día.',
      // Accesos
      no_registros_accesos: 'No hay registros de accesos para ese día.',
      // Accesos/Salidas
      mensaje_acercar_QR: 'Acerca el código QR a la cámara.',
      Leer: 'Leer',
      enviar: 'Enviar',
      enviado: 'Enviado',
      selecciona_caseta: 'Selecciona una Caseta',
      aceptar: 'Aceptar',
      no_resultados: 'Ningún Resultado',
      page_not_found: 'Página No Encontrada.!!!',
      page_not_found1: 'La URL',
      page_not_found2: 'solicitada no se encontró en este servidor.',
      inicio: 'Inicio',
      atras: 'Atrás',
      preregistro: 'Preregistro',
      registro_exito: 'Datos Enviados Correctamente',
      self_validate_exito: 'Datos Actualizados Correctamente',
      msj_cerrar_pagina: 'Tus datos están en proceso de Validación.',
      msj2_cerrar_pagina: 'Una vez validados se te notificará por SMS y/o E-Mail',
      msj3_cerrar_pagina: 'Gracias por validar tu información.',
      msj_cerrar_pagina_complemento: ' Puede cerrar esta página.',
      identidad_exito: 'Identidad Confirmada Correctamente',
      identidad_exito2: 'Gracias por Confirmar Identidad',
      identidad_desconocido: 'Invitado No reconocido.',
      identidad_desconocido2: 'En breve se eliminará este Invitado del Sistema.',
      pgt_seguro: '¿Está seguro que no conoce al invitado?',
      foto_perfil: 'Foto de Perfil',
      no_foto_perfil: 'Omitir Foto',
      confirmar_identidad: 'Confirmar Identidad',
      msg_know_guest: '¿Reconoce al Invitado?',
      msg_notificacion_anfitrion: 'Se ha enviado una Notificación al Anfitrión.',
      estado: 'Estado',
      current: 'Vigente',
      canceled: 'Cancelada',
      in_progress: 'En Proceso',
      done: 'Finalizado',
      adentro: 'Adentro',
      completado: 'Completado',
      subir_imagen: 'Subir Imagen',
      update_image: 'Actualizar Imagen',
      qr_code: 'Código QR',
      msg_qr_code: 'Introduce el Código QR',
      invitados: 'Invitado(s)',
      invitado: 'Invitado',
      invitados_no_confirmados: 'Invitado(s) Pendiente(s)',
      placeholder_invitados: 'Buscar por E-Mail',
      placeholder_invitados2: 'Buscar por Nombre o Apellido',
      placeholder_empresas: 'Buscar por Empresa',
      add_new_contact: 'Añadir Nuevo Contacto',
      sign_up_new_contact: 'Registrar Nuevo Contacto',
      add_new_employee: 'Añadir Nuevo Empleado',
      invitacion_grupal: 'Invitación Grupal',
      pagina_caduca: 'Esta Página ha Expirado.',
      msg_update_data: 'Gracias por tomarte el tiempo de actualizar tus datos.',
      aviso: 'Aviso',
      cancelar: 'Cancelar',
      detalle: 'Detalle',
      detalle_invit: 'Detalle de la Invitación',
      detalle_invit_recibidas: 'Detalle de la Invitación Recibida',
      detalle_access: 'Detalles del Acceso',
      detalle_access_without_code: 'Detalles del Acceso sin Código',
      pendiente: 'Pendiente',
      confirmed: 'Confirmada',
      cancellation_requested: 'Cancelación solicitada',
      cancelled: 'Cancelada',
      cancelled_plus_24h: 'Cancelada (+24h)',
      cancelled_minus_24h: 'Cancelada (-24h)',
      no_show: 'No Asistió',
      rejected: 'Rechazada',
      info_acceso: 'INFORMACIÓN DEL ACCESO',
      fecha_hora_acceso_in: 'Fecha y Hora del Acceso',
      fecha_hora_acceso_out: 'Fecha y Hora de Salida',
      pase_salida: 'Pase de Salida',
      confirmar: 'Confirmar',
      email_admin: 'E-Mail del Administrador',
      lbl_invit_empresarial: 'Invitación Empresarial',
      lbl_host_company: 'Empresa Anfitrión',
      add_equipo_seguridad: 'Agregar Equipo de Seguridad',
      mensaje_areas_equipo_alta: 'Equipo de Seguridad Agregado Correctamente.',
      mensaje_areas_equipo_update: 'Equipo de Seguridad Modificado Correctamente.',
      mensaje_areas_equipo_delete: 'Equipo de Seguridad Eliminado Correctamente.',
      lbl_invitacion_recurrente: 'Invitación Recurrente',
      Lunes: 'Lunes',
      Martes: 'Martes',
      Miercoles: 'Miércoles',
      Jueves: 'Jueves',
      Viernes: 'Viernes',
      Sabado: 'Sábado',
      Domingo: 'Domingo',
      lbl_selecciona_dias: 'Selecciona los días',
      access_days: 'Días de acceso',
      normal: 'Normal',
      empresarial: 'Empresarial',
      recurrente: 'Recurrente',
      msg_eliminar_empleado: '¿Está seguro de eliminar al Empleado?',
      msg_eliminar_invitacion: '¿Está seguro de eliminar la invitación?',
      msg_cancelar_invitacion: '¿Está seguro de cancelar la invitación?',
      msg_eliminar_invitacion_2: 'Esta acción no se puede deshacer.',
      mensaje_invitacion_delete: 'Invitación Eliminada Correctamente.',
      mensaje_invitacion_canceled: 'Invitación Cancelada Correctamente.',
      mensaje_empleado_delete: 'Empleado Eliminada Correctamente.',
      dias_validos: 'Días Válidos',
      empresa_procedencia: 'Empresa del Invitado',
      mg_enviado: 'Mensaje Enviado Correctamente',
      lbl_emergencia: 'Aviso: Se enviará un mensaje de Emergencia a todos los invitados dentro de la Empresa.',
      msg: 'Mensaje',
      recortar: 'Recortar',
      recortar_imagen: 'Recortar Imagen',
      frente: 'Frente',
      reverso: 'Atrás',
      siguiente: 'Siguiente',
      msg_no_days: 'Debe de seleccionar al menos un día para continuar.',
      cambiar_permisos: 'Cambiar Permisos',
      cambiar_contrasena: 'Cambiar Contraseña',
      move_up_user_to_resident: 'Usuario -> Dependiente',
      move_up_user_to_guard: 'Usuario -> Vigilante',
      move_up_user_to_manager: 'Usuario -> Administrador',
      move_up_user_to_main_resident: 'Usuario -> Titular',
      usuarios: 'Usuarios',
      msg_cambio_permisos: 'Permisos cambiados Correctamente.',
      msg_invitacion_confirmada: 'Invitación Confirmada Correctamente',
      asistira: '¿Asistirá?',
      print_name_tag: 'Imprimir Gafete',
      // Footer
      a_cerca_de: 'Acerca de',
      equipo: 'Equipo',
      servicios: 'Servicios',
      contacto: 'Contacto',
      sign_up_house: 'Registro de Titular',
      numero_casa: 'Número acción',
      nombre_calle: 'Nombre de la Calle',
      agregar_residente: 'Agregar Dependiente',
      editar_residente: 'Editar Dependiente',
      enviar_datos: 'Enviado Datos ...',
      intrare_residencial: 'Club Campestre',
      validar_datos_vivienda: 'Validar Datos del titular',
      datos_vivienda: 'Datos del Club',
      datos_residente_principal: 'Datos del Titular',
      datos_residentes: 'Datos de los Dependientes',
      detalle_residente: 'Detalles del Dependiente',
      msg_reconoce_residentes: '¿Reconoce al Titular?',
      continuar: 'Continuar',
      paso: 'Paso',
      acciones: 'Acciones',
      configuracion: 'Configuración',
      host_photo: 'Foto del anfitrión',
      casas: 'Número de acciones',
      accion: 'Número de acción',
      who_authorized: '¿Quién autorizó?',
      residente_principal: 'Titular',
      residentes: 'Dependientes',
      residente: 'Dependiente',
      main_residents: 'Titulares',
      msg_eliminar_registros: '¿Está seguro de eliminar el/los registro(s) seleccionado(s)?',
      msg_eliminar_casa: '¿Está seguro de eliminar el número de acción?',
      msg_delete_lot: '¿Está seguro de quitar el Lote?',
      msg_eliminar_directory: '¿Está seguro de eliminar el Registro?',
      msg_delete_court: '¿Está seguro de eliminar la Cancha?',
      msg_delete_schedule: '¿Está seguro de eliminar este Horario?',
      msg_delete_notice: '¿Está seguro de eliminar el Comunicado?',
      msg_delete_financial_statements: '¿Está seguro de eliminar el Estado financiero?',
      msg_delete_report: '¿Está seguro de eliminar el Reporte?',
      msg_eliminar_caseta: '¿Está seguro de eliminar la Caseta?',
      msg_delete_manager: '¿Está seguro de eliminar al Administrador?',
      msg_delete_guard: '¿Está seguro de eliminar al Vigilante?',
      msg_delete_resident: '¿Está seguro de eliminar al Dependiente?',
      msg_delete_worker: '¿Está seguro de eliminar al Trabajador?',
      msg_delete_main_resident: '¿Está seguro de eliminar al Titular?',
      msg_enable_main_resident: '¿Está seguro de Activar al Titular?',
      msg_disable_main_resident: '¿Está seguro de Desactivar al Titular?',
      msg_accion_deshacer: 'Esta acción no se puede deshacer.',
      codigo_pais: 'Código de País',
      ejemplo: 'Ejemplo: ',
      cellphone_wrong: 'Número de Celular Incorrecto',
      msg_usuario_sin_permisos: 'Usuario sin permisos, póngase en contacto con el Administrador.',
      msg_vigilant_sin_permisos: 'Vigilante sin permisos, póngase en contacto con el Administrador.',
      msg_user_delete: 'Usuario Eliminado Correctamente.',
      msg_user_invalidate: 'Se ha notificado al invitado, para corregir sus datos.',
      initialDate: 'Fecha Inicial',
      finalDate: 'Fecha Final',
      add_guest: 'Añadir Invitado',
      access_without_code: 'Acceso sin Código',
      select_video_device: 'Selecciona dispositivo de vídeo',
      start_camera: 'Iniciar Cámara',
      stop_camera: 'Detener Cámara',
      capture_photo: 'Capturar Foto',
      notificaciones: 'Notificaciones',
      canSendEmail: '¿Quieres recibir Correos?',
      canSendSMS: '¿Quieres recibir SMS',
      notificacion_success: 'Configuración Actualizada Correctamente.',
      rulebook_uploaded_successfully: 'Reglamento subido correctamente.',
      msg_offline: '¡No hay Conexión a Internet!',
      access_success: 'Acceso Registrado Correctamente.',
      msg_exit_time_registered: 'Hora de salida registrada Correctamente.',
      msg_captura_foto: 'Haga clic sobre el vídeo para capturar la imagen.',
      search_by_number_street_phone: 'Buscar por calle/número de casa/teléfono',
      search_by_number_street: 'Buscar por calle o número de casa',
      search_by_street: 'Buscar por calle',
      search_by_house_number: 'Buscar por Número de acción',
      search_by_street_house_number: 'Buscar por Calle/Número de Acción',
      search_by_house_number_resident: 'Buscar por Calle/Número de Acción/Nombre Dependiente',
      search_by_house_street_resident: 'Buscar por Calle/Nombre Dependiente',
      search_by_name: 'Buscar por Nombre',
      service_catalog: 'Catálogo de Servicios',
      search_by_name_visitor: 'Buscar por Notas o Nombre del Visitante',
      search_by_address_notes_name_guest: 'Buscar por Dirección/Notas/Nombre del Visitante',
      unique_resident: 'No tengo dependientes',
      msg_signup_apartment: 'Para iniciar con el Proceso de Registro, es necesario dar de Alta al Titular',
      place_holder_housing_units: 'Buscar por nombre',
      validado: 'Validado',
      validar: 'validar',
      msg_confirma_validacion_1: 'Debe de seleccionar ',
      or: 'o',
      msg_confirma_validacion_2: 'para continuar.',
      habitada: 'Habitada',
      deshabitada: 'Deshabitada',
      cambiar_wallpaper: 'Cambiar Imagen de Inicio',
      cambiar_wallpaper_exito: 'Imagen Cambiada Correctamente.',
      activar_desactivar: 'Activar/Desactivar',
      activar: 'Activar',
      desactivar: 'Desactivar',
      note_disable_main_resident: 'Nota: Al desactivar al Titular, éste y los dependientes que registró no podran enviar invitaciones.',
      note_enable_main_resident: 'Nota: Al activar al Titular, el Titular y los dependientes registrados podrán enviar invitaciones.',
      servicio_suspendido: 'Servicio Suspendido',
      msg_supendido: 'Este mensaje se muestra por cualquiera de las 2 siguientes razones:',
      msg_supendido1: 'Debido a que usted no tiene permisos para enviar invitaciones o',
      msg_supendido2: 'Debido a la falta de pago, el servicio de invitaciones ha sido suspendido.',
      msg_supendido3: 'Para más información comuníquese con su Titular o Administrador del Club.',
      importar_casas: 'Importar Número de acciones',
      importar: 'Importar',
      selecciona_archivo: 'Selecciona un Archivo de Excel.',
      selecciona_archivo_pdf: 'Selecciona un archivo PDF.',
      archivo: 'Archivo',
      importar_casas_archivo: 'Importar número de acciones desde archivo Excel.',
      import_account_statements_file: 'Importar estados de cuenta desde archivo Excel.',
      msg_importar_casas: 'Nota: El archivo para importar número de acciones debe cumplir con el siguiente formato.',
      mostrar_formato: 'Mostrar formato',
      msg_mi_codigo: 'Mi Código de Acceso',
      descargar: 'Descargar',
      renovar_codigos: 'Actualizar códigos QR',
      renovar_codigos_residentes: 'Actualizar códigos QR de los Titulares',
      msg_update_code_1: 'Permitir la actualización Mensual de Códigos QR de los Titulares de manera automática.',
      msg_update_code_2: 'Nota: Esta actualización  se ejecuta el primer día de cada mes a las 3:00 AM.',
      allow: 'Permitir',
      cambios_aplicados: 'Cambios Aplicados Correctamente',
      label: 'Etiqueta',
      classification: 'Clasificación',
      device: 'Dispositivo',
      no_devices: 'Sin Dispositivos',
      no_lots: 'Sin lotes registrados.',
      add_device: 'Añadir Dispositivo',
      device_added_successfully: 'Dispositivo Agregado Correctamente.',
      device_modified_successfully: 'Dispositivo Modificado Correctamente.',
      device_removed_successfully: 'Dispositivo Eliminado Correctamente.',
      lot_removed_successfully: 'Lote Eliminado Correctamente.',
      device_by_guardhouse: 'Dispositovo(s) por Caseta',
      delete: 'Eliminar',
      change: 'Modificar',
      show_devices: 'Mostrar Dispositivos',
      show_lots: 'Mostrar lotes',
      details: 'Detalles',
      show_details: 'Mostrar Detalles',
      msg_info_details: 'Esta información solo es visible para el Administrador.',
      lanesQR: 'Carriles con Lector de QR',
      lanesCam: 'Carriles con Cámara',
      devices: 'Dispositivos',
      grados: 'Grados',
      msg_can_not_delete_house01: 'No es posible Eliminar la Casa',
      msg_can_not_delete_house02: 'Actualmente un Titular o más la estan ocupando. Elimine primero al Titular.',
      no_records_yet: 'Sin registros todavía.',
      canceled_invitation: '¡INVITACIÓN CANCELADA!',
      msg_canceled_invitation_offline: 'Esta invitación ha sido cancelada por el Anfitrión.',
      msg_canceled_invitation: '¡ACCESO DENEGADO! .Esta invitación ha sido cancelada por el Anfitrión.',
      msg_vacation_mode_activate: '¡ACCESO DENEGADO! Por el momento la casa no está recibiendo visitas.',
      msg_out_date: '¡ACCESO DENEGADO! .Esta invitación esta fuera de fecha o ha expirado.',
      msg_out_date2: '¡ACCESO DENEGADO!. Esta invitación ha expirado.',
      msg_out_date3: '¡ACCESO DENEGADO!. No esta autorizado la entrada para este dia.',
      msg_out_date_worker0: '¡ACCESO DENEGADO!. Este trabajador no tiene autorizado la entrada para este dia.',
      msg_out_date_worker1: '¡ACCESO DENEGADO!. El plazo para acceder de este trabajador ha expirado.',
      export_to_pdf: 'Exportar a PDF',
      access_report_no_code: 'Reporte de accesos sin código',
      period: 'Período: ',
      page: 'Página ',
      al: ' al ',
      de: ' de ',
      allow_device: 'Permitir dispositivo',
      show_current_invitations: 'Mostrar invitaciones vigentes',
      msg_allow_device: '¿Quiere que el/los Vigilantes inicien sesión desde este navegador?',
      show_house_phones: 'Mostrar teléfonos de casa',
      msg_allow_show_house_phones: '¿Quieres que los Vigilantes puedan ver los teléfonos de las casas?',
      msg_allow_show_current_invitations: '¿Quieres que los Vigilantes puedan ver las invitaciones vigentes del dia?',
      msg_enable_ine_photo: '¿Qué foto del anfitrión quieres que se muestre al Vigilante cuando se despliegue la información de la invitación?',
      info_enable_ine_photo: 'Nota: Al activar esta opción los vigilantes podrán ver la Identificación del invitado, por lo que el trato otorgado a la información presentada es responsabilidad del cliente.',
      booth_registration: 'Registro en caseta',
      notice: 'Comunicado',
      title: 'Titulo',
      comments: 'Comentarios',
      no_comment: 'Sin Comentarios',
      administrator_comments: 'Comentarios del Administrador',
      file: 'Archivo',
      msg_overflow_file: '¡El tamaño del archivo debe ser inferior a 2 MB!',
      report: 'Reporte',
      type_reports: 'Categoria del Reporte',
      type_notices: 'Categoria del Comunicados',
      choose_category: 'Elige una categoría',
      evidence: 'Evidencia',
      msg_evidence: 'Si quiere agregar una fotografía como evidencia marque la casilla Agregar Archivo y posteriormente seleccione la fotografia.',
      no_vidence: 'No se adjuntó evidencia.',
      send_approval_request: 'Enviar solicitud de aprobación',
      approve: 'Aprobar',
      reject: 'Rechazar',
      send_communications: 'Enviar comunicados',
      send_communication_selected_owners: 'Enviar comunicado a los socios seleccionados',
      send_communication_owners: 'Enviar este comunicado a socios',
      directory: 'Directorio',
      show_vehicle_plates: 'Mostrar placas del vehículo',
      vehicle_plates: 'Placas del vehículo',
      send_email_update: 'Enviar E-Mail, validación/actualización de datos',
      hide_video: 'Ocultar video',
      show_video: 'Mostrar video',
      show_qr_code: 'Mostrar código QR',
      display_info_print: 'Visualizar información para imprimir',
      generate_pdf_printing: 'Generar PDF para imprimir',
      number_cards_sheet: 'Número de tarjetas por hoja',
      supplier: 'Proveedor',
      q_supplier: '¿Es proveedor?',
      supplier_mode: 'Modo Proveedor: ',
      msg_supplier: 'Esta persona ha sido invitada en modo proveedor, favor de realizar el protocolo de seguridad para proveedores.',
      tooltip_supplier: 'Si tu visita va a realizar algún servicio o entrega en tu domicilio, indícale al fraccionamiento para agilizar su entrada y que sea realizado el protocolo de seguridad para proveedores.',
      account_statements: 'Estados de Cuenta',
      relate_home: 'Relacionar casa',
      vacation_mode: 'Modo vacaciones: ',
      msg_vacation_mode: 'Por el momento la casa no está recibiendo visitas.',
      allow_access_visitors: 'Permitir acceso a visitantes',
      allow_access_residents: 'Permitir acceso a dependientes',
      allow_access_workers: 'Permitir acceso a trabajadores',
      rulebook: 'Reglamento',
      guardhouse_name_checkin: 'Caseta Entrada',
      guardhouse_name_checkout: 'Caseta Salida',
      current_invitations: 'Invitaciones vigentes',
      data_correction_form: 'Formulario corrección datos',
      data_correction: 'Corrección de datos',
      msg_photograph_blurred: 'Fotografía de identificación oficial no se distingue (borrosa)',
      send_correction_request: 'Enviar solicitud de corrección.',
      data_correction_sent: 'Corrección de datos enviada.',
      additional_comments: 'Comentarios adicionales',
      msg_additional_comments: 'Escribir comentarios adicionales. \nNota: estos comentarios se anexaran al correo.',
      additional_person: 'Agregar persona',
      msg_additional_person: 'El invitado viene con más personas',
      show_additional_people: 'Mostrar personas adicionales',
      additional_people: 'Personas adicionales',
      show_all_residents: 'Ver todos',
      show_secondary_residents: 'Mostrar dependientes',
      msg_no_registered_secondary_residents_yet: 'Este Titular aún no ha registrado dependientes.',
      register: 'Registrar',
      register_parcel: 'Registrar paquetería',
      addressee: 'Destinatario',
      guide_number: 'Número de guía',
      company: 'Compañía',
      who_delivered: '¿Quién entregó?',
      who_received: '¿Quien recibió?',
      package_delivery: 'Entrega de paquetes ',
      parcel: 'Paquetería',
      date_time_receipt: 'Fecha y hora recibo',
      delivery_date_time: 'Fecha y hora entrega',
      in_booth: 'En caseta',
      delivered: 'Entregado',
      payroll_number: 'Número de nómina',
      position: 'Cargo',
      instructor_name: 'Nombre del instructor',
      description: 'Descripción',
      import_titulars: 'Importar titulares',
      titulars_imported_correctly: 'Titulares importados correctamente.',
      booking: 'Reservaciones',
      create_booking: 'Crear reservación',
      reservation_created_successfully: 'Reservación creada correctamente.',
      confirm_booking: 'Confirmar reservación',
      reservation_confirmed_successfully: 'Reservación confirmada correctamente.',
      reject_reservation: 'Rechazar reservación',
      reservation_successfully_rejected: 'Reservación rechazada correctamente.',
      cancel_reservation: 'Cancelar Reservación',
      reservation_successfully_canceled: 'Reservación cancelada exitosamente.',
      courts: 'Canchas',
      choose_court: 'Selecciona una cancha',
      choose_owner: 'Selecciona un socio',
      booking_created_by: 'Reservación creada por:',
      booking_in_name_of: 'Reservación a nombre de:',
      error_msg_0: 'Las reservaciones deben realizarse con al menos 30 minutos de anticipación.',
      reservation_time: 'Hora de reservación',
      add_player: 'Jugador adicional',
      choose_time: 'Selecciona un tiempo',
      choose_type: 'Selecciona un tipo',
      choose_motive: 'Selecciona un motivo',
      court_created_successfully: 'Cancha creada correctamente.',
      court_updated_successfully: 'Cancha actualizada correctamente.',
      court_deleted_successfully: 'Cancha eliminada correctamente.',
      msg_warning_court: 'Al eliminar esta cancha también se eliminarán todas las reservaciones de la misma.',
      open: 'Abierto',
      closed_due_to_rain: 'Cerrado por lluvia',
      closed_due_to_lightning_storm: 'Cerrado por tormenta eléctrica',
      open_with_damaged_greens: 'Abierto con greenes dañados',
      close_court: 'Cerrar Cancha',
      open_court: 'Abrir Cancha',
      motive: 'Motivo',
      closing_start_date_time: 'Inicio de cierre',
      closing_end_date_time: 'Fin de cierre',
      court_closed_successfully: 'Cancha cerrada exitosamente',
      // Golf Module
      golf_courts: 'Configuración de campo',
      add_golf_court: 'Agregar Salida',
      golf_court_name: 'Nombre de la Salida',
      golf_court_type: 'Tipo de Salida',
      total_holes: 'Total de Hoyos',
      hole_range_start: 'Hoyo Inicial',
      hole_range_end: 'Hoyo Final',
      minutes_per_hole: 'Minutos por Hoyo',
      time_interval: 'Intervalo de Tiempo (min)',
      opening_days: 'Días de Apertura',
      golf_court_details: 'Detalles de Salida',
      hole_range: 'Rango de Hoyos',
      days_open: 'Días Abierto',
      delete_golf_court_confirm: '¿Estás seguro de que quieres eliminar esta salida? Esta acción no se puede deshacer.',
      confirm_cancel_reservation: '¿Estás seguro de cancelar esta reservación?',
      delete_golf_court_title: '¿Eliminar Salida?',
      standard: 'Estándar',
      professional: 'Profesional',
      practice: 'Práctica',
      dom: 'Dom',
      lun: 'Lun',
      mar: 'Mar',
      mie: 'Mié',
      jue: 'Jue',
      vie: 'Vie',
      sab: 'Sáb',
      new_golf_court: 'Nueva Salida',
      edit_golf_court: 'Editar Salida',
      view_details: 'Ver Detalles',
      edit: 'Editar',
      delete_action: 'Eliminar',
      active: 'Activo',
      inactive: 'Inactivo',
      required_field: 'Este campo es requerido.',
      positive_number_error: 'Debe ser un número positivo.',
      // Golf Reservations
      golf_reservations: 'Reservaciones de salida',
      new_reservation: 'Nueva Reservación',
      edit_reservation: 'Editar Reservación',
      reservation_date: 'Fecha',
      golf_court: 'Hoyo de salida',
      holder: 'Titular Salida',
      caddie: 'Caddie',
      players: 'Jugadores Adicionales',
      player_names: 'Nombres de Jugadores',
      reservation_status: 'Estado',
      pending: 'Pendiente',
      reservations_for: 'Reservaciones para',
      no_reservations_for_date: 'No hay reservaciones para esta fecha',
      start_hole: 'Hoyo de Inicio',
      hole_count: 'Cantidad de Hoyos',
      press_enter_to_add_names: 'Presiona Enter para agregar nombres',
      reservation_cancelled_success: 'Reservación cancelada exitosamente',
      error_fetching_reservations: 'Error al obtener reservaciones',
      error_cancelling_reservation: 'Error al cancelar reservación',
      reservation_updated_success: 'Reservación actualizada exitosamente',
      reservation_created_success: 'Reservación creada exitosamente',
      error_saving_reservation: 'Error al guardar reservación',
      status_updated_success: 'Estado actualizado exitosamente',
      error_updating_status: 'Error al actualizar estado',
      requests: 'Solicitudes',
      calendar_view: 'Calendario',
      accept_cancellation: 'Aceptar Cancelación',
      reject_cancellation: 'Rechazar Cancelación',
      confirm_reservation: 'Confirmar Reservación',
      cancellations: 'Cancelaciones',
      is_recurring: 'Es recurrente',
      end_date: 'Vencimiento',
      days_of_week: 'Días de la semana',
      recurring_reservations_created_success: 'Reservaciones recurrentes creadas exitosamente',
      guest: 'Invitado',
      guest_name: 'Nombre del Invitado',
      caddies: 'Caddies',
      caddie_type_first: 'Primera',
      caddie_type_second: 'Segunda',
      caddie_type_bag: 'Carga de Bolsa',
      others: 'otros',
      caddie_created_success: 'Caddie creado exitosamente',
      caddie_updated_success: 'Caddie actualizado exitosamente',
      caddie_deleted_success: 'Caddie eliminado exitosamente',
      max_players_reached: 'Se ha alcanzado el límite de 6 jugadores (incluyendo al titular).',
      // Golf Blacklist
      golf_blacklist: 'Socios con restricción',
      add_to_blacklist: 'Agregar a Socios con restricción',
      reason: 'Motivo',
      unlock_date: 'Fecha de Desbloqueo',
      blocked_user: 'Usuario Bloqueado',
      remove_from_blacklist: 'Quitar de Socios con restricción',
      confirm_remove_blacklist: '¿Estás seguro de desbloquear a este usuario?',
      permanent: 'Permanente',
      // Golf Dashboard
      golf_administration: 'Administración de Golf',
      select_option_admin: 'Selecciona una opción para administrar',
      manage_golf_course: 'Administrar configuración de campo',
      manage_reservations: 'Administrar las reservaciones de salida de los usuarios',
      manage_blacklist: 'Administrar Socios con restricción',
      // Golf Court Statuses
      court_status_open: 'Abierto',
      court_status_rain: 'Cerrado por lluvia',
      court_status_storm: 'Cerrado por tormenta eléctrica',
      court_status_minor_damage: 'Abierto con daños menores',
      court_status_damaged_greens: 'Abierto con greenes dañados',
      court_status_maintenance: 'Cerrado por mantenimiento',
      hole: 'Hoyo',
      holes: 'Hoyos',
      reservation_details: 'Detalles de Reservación',
      date: 'Fecha',
      time: 'Hora',
      // Blacklist additional translations
      permanent_hint: 'Dejar vacío para bloqueo permanente',
      error_fetching_users: 'Error al obtener usuarios',
      error_fetching_blacklist: 'Error al obtener lista de Socios con restricción',
      removed_from_blacklist_success: 'Usuario desbloqueado exitosamente',
      error_removing_blacklist: 'Error al desbloquear usuario',
      blacklist_updated_success: 'Lista de Socios con restricción actualizada exitosamente',
      added_to_blacklist_success: 'Usuario agregado a Socios con restricción exitosamente',
      error_saving_blacklist: 'Error al guardar en Socios con restricción',
      no_users_found: 'No se encontraron usuarios',
      restricted_until: 'Restringido hasta',
      mark_as_no_show: 'Marcar como No Asistió',
      confirm_no_show: '¿Estás seguro de marcar esta reservación como No Asistió? Se agregará un strike al usuario.',
      no_show_success: 'Reservación marcada como No Asistió y se agregó un strike al usuario.',
      error_marking_no_show: 'Error al marcar como No Asistió',
      strikes: 'Strikes',
      automatic_strike_system: 'Sistema automático de strikes',
      reset_strikes: 'Resetear Strikes',
      confirm_reset_strikes: '¿Estás seguro de que deseas resetear los strikes de este usuario?',
      reset_strikes_info: 'Esto pondrá los strikes en 0 y desactivará la restricción.',
      strikes_reset_success: 'Strikes reseteados exitosamente',
      error_resetting_strikes: 'Error al resetear strikes',
      unban_info: 'Esto desactivará la restricción pero mantendrá el historial de strikes.',
      banned: 'Restringido',
      // Golf Caddies
      golf_caddies: 'Caddies',
      add_caddie: 'Agregar Caddie',
      caddie_name: 'Nombre del Caddie',
      caddie_details: 'Detalles del Caddie',
      new_caddie: 'Nuevo Caddie',
      edit_caddie: 'Editar Caddie',
      delete_caddie_title: '¿Eliminar Caddie?',
      delete_caddie_confirm: '¿Estás seguro de que quieres eliminar este caddie? Esta acción no se puede deshacer.',
      manage_caddies: 'Administrar caddies del campo de golf'
    },
    en: {
      // Login
      mensaje_login: 'Access to the system',
      ingresar: 'Login',
      mensaje_olvidar_contrasena: 'Did you forget your password?',
      mensaje_link_restablecer1: 'Click ',
      mensaje_link_restablecer2: 'here',
      mensaje_link_restablecer3: 'to reset it.',
      msg_password_reset: 'Enter your E-Mail and then we will send you a temporary password.',
      msg_password_reset_done1: 'We have sent you a temporary password by E-Mail.',
      msg_password_reset_done2: 'You should receive the email shortly!',
      Bienvenido: 'Welcome',
      agregar: 'Add',
      quitar: 'Remove',
      modificar: 'Change',
      cerrar: 'Close',
      Buscar: 'Search',
      ningun_resultado_1: 'The search for',
      ningun_resultado_2: 'found no results.',
      prep_de: 'of',
      filas_por_pagina: 'Rows per page',
      todos: 'All',
      region: 'en-US',
      Ayuda: 'Help',
      Administrador: 'Manager',
      Vigilante: 'Guard',
      SuperAdministrador: 'SuperManager',
      // Menú Empleado
      Historial_Invitaciones_Enviadas: 'History of invitations Sent',
      Historial_Invitaciones_Recibidas: 'History of invitations received',
      Historial_Accesos_Trabajadores: 'Workers Access History',
      Historial_Accesos_Biometrico: 'Biometric Access History',
      Historial_Accesos: 'Access History',
      Historial: 'Record',
      Historial_avanzado: 'Advanced record',
      // Menú Vigilante
      bitacora: 'Log',
      entradas_salidas: 'Check In/Check Out',
      check_in_time: 'Check in time',
      check_out_time: 'Check out time',
      acceso_sin_codigo: 'Check In Without Code',
      historial_accesos_sin_codigo: 'Access history without code',
      // Menú Administrador
      Invitaciones: 'Invitations',
      Accesos: 'Access',
      firma_salida: 'Sign exit pass',
      firmado: 'Signed',
      no_firmado: 'Unsigned',
      firmar: 'Sign it',
      mensaje_pase_salida_firmado: 'Exit pass signed successfully.',
      no_registros_pase_salida: 'There are no access records.',
      mensaje_pase_salida: 'People within the Company',
      Casetas: 'Guard Houses',
      Vigilantes: 'Guards',
      boton_emergencia: 'Emergency Button',
      // Empleados
      Empleados: 'Employees',
      AnadirEmpleado: 'Add Employee',
      mensaje_empleado_alta: 'Employee Added Successfully.',
      mensaje_empleado_modificado: 'Employee Modified Correctly.',
      Area: 'Area',
      Nombre: 'First Name',
      Apellido: 'Last Name',
      Invitacion: 'Invitation',
      puede_enviar: 'You can send invitations',
      rented_house: 'Rented house',
      renting_house: 'Check the box if the person is renting the house.',
      extension: 'Extension',
      ine_frente: 'Image front identification',
      foto_ine: 'Official Photo Identification (Driver License, Passport)',
      ine_atras: 'Image back Identification',
      celular: 'Cell phone',
      password: 'Password',
      current_password: 'Current Password',
      new_password: 'New Password',
      password_new_confirm: 'Confirm New Password',
      msg_cambio_password: 'Password changed Successfully.',
      password_confirm: 'Confirm Password',
      Activo: 'Active',
      // Vigilantes
      anadir_vigilante: 'Add Guard',
      mensaje_vigilante_alta: 'Guard Added Successfully.',
      mensaje_vigilante_modificado: 'Guard Modified Successfully.',
      mensaje_vigilante_eliminado: 'Guard Removed Successfully.',
      mostrar_info_invit: 'Show invitation information',
      info_invitation: 'INVITATION INFORMATION',
      info_residente: 'MEMBER INFORMATION',
      info_worker: 'WORKER INFORMATION',
      info_invitado: 'GUEST INFORMATION',
      info_anfitrion: 'HOST INFORMATION',
      info_access: 'ACCESS INFORMATION',
      datos_coche: 'Car data',
      guardar: 'Save',
      acceso: 'Access',
      registrar_salida: 'Check Out',
      form_salida: 'Exit Form',
      mensaje_alta_acceso_in: 'Registered Access Successfully.',
      mensaje_alta_acceso_out: 'Registered Exit Successfully.',
      mensaje_qr_no_valido: 'QR code, Invalid.',
      mensaje_qr_multiple: 'Something went wrong, multiple records with the same QR Code.',
      mensaje_qr_no_valido_fraccionamiento: 'This invitation does not correspond to this Club.',
      mensaje_acceso_completo: 'Access has already been completed with the corresponding invitation.',
      mensaje_alta_acceso_without: 'Access Registered Successfully.',
      // Residentes
      anadir_residente: 'Add Dependent',
      mensaje_residente_alta: 'Dependent Added Successfully.',
      mensaje_residente_modificado: 'Dependent Modified Successfully.',
      mensaje_residente_eliminado: 'Dependent Removed Successfully.',
      // Trajadores
      worker: 'Worker',
      workers: 'Workers',
      add_worker: 'Add Worker',
      msg_worker_added: 'Worker Added Successfully.',
      msg_worker_update: 'Worker Modified Successfully.',
      msg_worker_deleted: 'Worker Removed Successfully.',
      // Guest
      mensaje_invitado_alta: 'Guest Added Successfully.',
      // Invitación
      Empleado: 'Employee',
      fecha_hora: 'Date and Hour for Invitation',
      fecha_inv: 'Date for Invitation',
      fecha_expiracion: 'Expiration date',
      fecha_inicial: 'Initial date',
      creation_date: 'Creation Date',
      finish_date: 'Finish date',
      hora_inv: 'Hour for Invitation',
      Asunto: 'Subject',
      placeholder_asunto: 'Write the Subject of the Invitation',
      mensaje_equipo: 'Required safety equipment:',
      equipo_seguridad: 'Equipment',
      mensaje_vehiculo: 'Access with vehicle?',
      enviar_codigo: 'Send Code',
      Notas: 'Notes',
      placeholder_notas: 'Write Extra Notes for the Invitation',
      Si: 'Yes',
      invitación_referido: 'Referred Invitation',
      ininvitación_normal: 'Invitation',
      mensaje_invitacion_alta: 'Invitation Sent Successfully.',
      // Empresas
      Empresas: 'Companies',
      AnadirFraccionamiento: 'Add Club',
      telefono: 'Telephone',
      logotipo: 'Logotype',
      pagina_web: 'Web page',
      clasificacion: 'Classification',
      latitud: 'Latitude',
      longitud: 'Longitude',
      url_mapa: 'URL map',
      vigencia: 'Expiration Date',
      Parque: 'Park',
      mensaje_empresa_alta: 'Club Added Successfully.',
      mensaje_empresa_modificado: 'Club Modified Successfully.',
      // Parques
      Fraccionamientos: 'Clubs',
      Fraccionamiento: 'Club',
      AnadirFraccionamientos: 'Add Club',
      nombre: 'Name',
      full_name: 'Full name',
      direccion: 'Address',
      mensaje_parque_alta: 'Park Added Successfully.',
      mensaje_parque_modificado: 'Park Modified Successfully.',
      // Jefes de Departamento
      department_manager: 'Department manager',
      add_department_manager: 'Add Department manager',
      msg_department_manage_added: 'Department manager Added Successfully',
      msg_department_manage_updated: 'Department manager Modified Successfully.',
      // Roles y Permisos
      roles_permisos: 'Roles & Permissions',
      rol_department_manager: 'Department Manager',
      rol_starter: 'Starter',
      rol_associates: 'Associates Management',
      rol_account_statements: 'Account Statements',
      rol_sports: 'Sports Module',
      rol_employees: 'Employees Management',
      rol_golf_admin: 'Golf Administrator',
      // Modal Department Manager
      edit_department_manager: 'Edit Department Manager',
      datos_personales: 'Personal Information',
      documentos: 'Documents',
      permisos: 'Permissions',
      credenciales: 'Access Credentials',
      cambiar_password: 'Change Password',
      // Administradores
      Administradores: 'Managers',
      anadir_administrador: 'Add Manager',
      anadir_main_resident: 'Add Associate',
      Empresa: 'Company',
      mensaje_administrador_alta: 'Manager Added Successfully',
      mensaje_administrador_modificado: 'Manager Modified Successfully.',
      mensaje_administrador_eliminada: 'Manager Removed Successfully.',
      mensaje_mainresident_alta: 'Associate Added Successfully.',
      mensaje_mainresident_modificado: 'Associate Modified Successfully.',
      mensaje_mainresident_eliminado: 'Associate Removed Successfully.',
      mensaje_users_alta: 'Validated Users Successfully.',
      mensaje_users_baja: 'Users Deleted Successfully.',
      mensaje_accessnocode_baja: 'Record(s) Deleted Successfully.',
      mensaje_email_sent: 'Email sent successfully.',
      mensaje_users_activados: 'Users enabled successfully.',
      mensaje_users_desactivados: 'Users disabled successfully.',
      // Áreas
      Areas: 'Areas',
      add_area: 'Add Area ',
      msg_area_added: 'Area Added Successfully.',
      msg_area_updated: 'Area Modified Successfully.',
      mensaje_casas_importadas: 'Successfully imported action number.',
      account_statements_imported_correctly: 'Account statements imported successfully.',
      anadir_casa: 'Add action number',
      mensaje_casa_alta: 'Action number Added Successfully.',
      mensaje_casa_modificado: 'Action number Modified Successfully.',
      mensaje_casa_eliminada: 'Action number Removed Successfully.',
      // Relacionar Casas para estado de cuenta
      msg_relate_home_add: 'Associated House successfully.',
      msg_lot_add: 'Lot Added Successfully.',
      msg_relate_home_update: 'Record Modified Successfully.',
      msg_relate_home_delete: 'Record Removed Successfully.',
      // Directorio
      add_directory: 'Add',
      mensaje_directory_alta: 'Record Added Successfully.',
      mensaje_directory_modificado: 'Record Modified Successfully.',
      mensaje_directory_eliminada: 'Record Removed Successfully.',
      // Paqueteria
      mensaje_paqueteria_alta: 'Package added successfully.',
      mensaje_paqueteria_entregado: 'Package delivered successfully.',
      // Notices
      Notices: 'Notices',
      add_notice: 'Add notice',
      msg_added_notice: 'Notice added successfully.',
      msg_notice_updated: 'Notice modified successfully.',
      msg_notice_deleted: 'Notice removed successfully.',
      // Financial Statements
      financial_statements: 'Financial Statements',
      add_financial_statements: 'Add financial statements',
      msg_added_financial_statement: 'Financial statements added successfully.',
      msg_financial_statement_updated: 'Financial statements modified successfully.',
      msg_financial_statement_deleted: 'Financial statements removed successfully.',
      // Generic Notices
      msg_generic_notice_send: 'Your request has been submitted successfully.',
      msg_generic_notice_approval: 'Notice approved successfully.',
      msg_generic_notice_reject: 'Notice reject successfully.',
      msg_notice_user_deleted: 'Notice for that owner removed successfully.',
      msg_notice_user_added: 'Notice for that owner added successfully.',
      msg_notice_user_sent: 'Notice sent successfully.',
      // Reports
      Reports: 'Reports',
      add_report: 'Add Report',
      msg_added_report: 'Report added successfully.',
      msg_report_updated: 'Report modified successfully.',
      msg_report_deleted: 'Report removed successfully.',
      // Deportes
      sports: 'Sports',
      sport: 'Sport',
      add_sport: 'Add Sport',
      select_color: 'Select a color',
      sports_schedules: 'Sports schedules',
      choose_sport: 'Choose a sport',
      choose_day: 'Choose the day',
      msg_sport_added: 'Sport added successfully.',
      msg_sport_updated: 'Sport modified successfully.',
      add_sport_schedule: 'Add schedule',
      schedule: 'Schedule',
      msg_schedule_added: 'Schedule added Successfully.',
      msg_schedule_updated: 'Schedule modified successfully.',
      msg_schedule_deleted: 'Schedule removed Successfully.',
      // Casetas
      anadir_caseta: 'Add Guard House',
      mensaje_caseta_alta: 'Guard House Added Successfully.',
      mensaje_caseta_modificada: 'Guard House Modified Successfully.',
      mensaje_caseta_eliminada: 'Guard House Removed Successfully.',
      // Contactos
      contactos: 'Contacts',
      anadir_contacto: 'Add Contact',
      mensaje_contacto_alta: 'Contact Added Successfully.',
      mensaje_contacto_modificado: 'Contact Modified Correctly.',
      // Grupos
      grupos: 'Groups',
      anadir_grupo: 'Add Group',
      mensaje_grupo_alta: 'Group Added Successfully.',
      mensaje_grupo_modificado: 'Group Modified Successfully.',
      mensaje_grupo_delete: 'Group Removed Successfully.',
      eliminar: 'Delete',
      // ContactosXGrupo
      contactosXgrupo: 'Contacts By Group',
      mensaje_contactoXgrupo_alta: 'Contact Added Correctly to the Group.',
      mensaje_contactoXgrupo_delete: 'Contact Deleted from the Group Correctly.',
      // Invitaciones
      Filtrar: 'Filter',
      select_fecha: 'Select date:',
      mostrando_inv_dia: 'Showing invitations of the day:',
      mostrando_historial_dia: 'Showing History Day:',
      Fecha: 'Date',
      Hora: 'Time',
      Visitante: 'Guest',
      Anfitrion: 'Host',
      hora_acceso: 'Entry time ',
      hora_salida: 'Departure time',
      opening_time: 'Opening time',
      closing_time: 'Closing time',
      Tipo: 'Type',
      weekday: 'Weekday',
      no_registros_invit: 'There are no invitation records for that day.',
      // Accesos
      no_registros_accesos: 'There are no access records for that day.',
      // Accesos/Salidas
      mensaje_acercar_QR: 'Bring the QR code closer to the camera.',
      Leer: 'Read',
      enviar: 'Send',
      enviado: 'Sent',
      selecciona_caseta: 'Choose a Guard House',
      aceptar: 'Accept',
      no_resultados: 'No results',
      page_not_found: 'Page not found. !!!',
      page_not_found1: 'The requested URL',
      page_not_found2: 'was not found on this server.',
      inicio: 'Home',
      atras: 'Back',
      preregistro: 'Pre-registration',
      registro_exito: 'Data Sent Successfully',
      self_validate_exito: 'Data updated successfully',
      msj_cerrar_pagina: 'Your data is in the process of validation.',
      msj2_cerrar_pagina: 'Once validated you will be notified by SMS and / or E-Mail.',
      msj3_cerrar_pagina: 'Thank you for validating your information.',
      msj_cerrar_pagina_complemento: 'You can close this page.',
      identidad_exito: 'Identity Confirmed Correctly',
      identidad_exito2: 'Thank you for Confirming Identity',
      identidad_desconocido: 'Guest unrecognized.',
      identidad_desconocido2: 'Shortly this Guest will be removed from the System.',
      pgt_seguro: 'Are you sure you don\'t know the guest?',
      foto_perfil: 'Profile Picture',
      no_foto_perfil: 'Skip photo',
      confirmar_identidad: 'Confirm Identity',
      msg_know_guest: 'Do you recognize the Guest?',
      msg_notificacion_anfitrion: 'A Notification has been sent to the Host.',
      estado: 'Status',
      current: 'Current',
      canceled: 'Canceled',
      in_progress: 'In progress',
      done: 'Done',
      adentro: 'Inside',
      completado: 'Completed',
      subir_imagen: 'Upload Image',
      update_image: 'Update Image',
      qr_code: 'QR Code',
      msg_qr_code: 'Enter QR Code',
      invitados: 'Guest(s)',
      invitado: 'Guest',
      invitados_no_confirmados: 'Pending Guest(s)',
      placeholder_invitados: 'Search by E-Mail',
      placeholder_invitados2: 'Search by First name or Last name',
      placeholder_empresas: 'Search by Company',
      add_new_contact: 'Add New Contact',
      sign_up_new_contact: 'Register New Contact',
      add_new_employee: 'Add New Employee',
      invitacion_grupal: 'Group Invitation',
      pagina_caduca: 'This page has expired.',
      msg_update_data: 'Thank you for taking the time to update your information.',
      aviso: 'Notice',
      cancelar: 'Cancel',
      detalle: 'Detail',
      detalle_invit: 'Invitation Details',
      detalle_invit_recibidas: 'Detail of the Invitation Received',
      detalle_access: 'Access Details',
      detalle_access_without_code: 'Access Without Code Details',
      pendiente: 'Pending',
      confirmed: 'Confirmed',
      cancellation_requested: 'Cancellation requested',
      cancelled: 'Cancelled',
      cancelled_plus_24h: 'Cancelled (+24h)',
      cancelled_minus_24h: 'Cancelled (-24h)',
      no_show: 'No Show',
      rejected: 'Rejected',
      info_acceso: 'ACCESS INFORMATION',
      fecha_hora_acceso_in: 'Date and Time of Access',
      fecha_hora_acceso_out: 'Date and time of departure',
      pase_salida: 'Pass out',
      confirmar: 'Confirm',
      email_admin: 'Email Manager',
      lbl_invit_empresarial: 'Business Invitation',
      lbl_host_company: 'Host Company',
      add_equipo_seguridad: 'Add security equipment',
      mensaje_areas_equipo_alta: 'Security Equipment Removed Successfully.',
      mensaje_areas_equipo_update: 'Security Equipment Modified Successfully.',
      mensaje_areas_equipo_delete: 'Security Equipment Removed Successfully.',
      lbl_invitacion_recurrente: 'Recurrent Invitation',
      Lunes: 'Monday',
      Martes: 'Tuesday',
      Miercoles: 'Wednesday',
      Jueves: 'Thursday',
      Viernes: 'Friday',
      Sabado: 'Saturday',
      Domingo: 'Sunday',
      lbl_selecciona_dias: 'Select days',
      access_days: 'Access days',
      normal: 'Normal',
      empresarial: 'Enterprise',
      recurrente: 'Recurrent',
      msg_eliminar_empleado: 'Are you sure to delete the Employee?',
      msg_eliminar_invitacion: 'Are you sure to delete the invitation?',
      msg_cancelar_invitacion: 'Are you sure to cancel the invitation?',
      msg_eliminar_invitacion_2: 'This action can not be undo',
      mensaje_invitacion_delete: 'Invitation Removed Successfully.',
      mensaje_invitacion_canceled: 'Invitation Canceled Successfully.',
      mensaje_empleado_delete: 'Employee Removed Successfully.',
      dias_validos: 'Valid Days',
      empresa_procedencia: 'Guest Company',
      mg_enviado: 'Message sent successfully',
      lbl_emergencia: 'Notice: An Emergency message will be sent to all guests within the Company.',
      msg: 'Message',
      recortar: 'Cut',
      recortar_imagen: 'Crop Image',
      frente: 'Front',
      reverso: 'Back',
      siguiente: 'Next',
      msg_no_days: 'You must select at least one day to continue.',
      cambiar_permisos: 'Change Permissions',
      cambiar_contrasena: 'Change Password',
      move_up_user_to_resident: 'User -> Dependent',
      move_up_user_to_guard: 'User -> Guard',
      move_up_user_to_manager: 'User -> Manager',
      move_up_user_to_main_resident: 'User -> Associate',
      usuarios: 'Users',
      msg_cambio_permisos: 'Permissions changed successfully.',
      msg_invitacion_confirmada: 'Confirmed Invitation Successfully.',
      asistira: 'Will attend?',
      print_name_tag: 'Print name tag',
      // Footer
      a_cerca_de: 'About Us',
      equipo: 'Team',
      servicios: 'Services',
      contacto: 'Contact Us',
      sign_up_house: 'Sign Up Associate',
      numero_casa: 'Action number',
      nombre_calle: 'Street Name',
      agregar_residente: 'Add Dependent',
      editar_residente: 'Edit Dependent',
      enviar_datos: 'Sending data  ...',
      intrare_residencial: 'Club Campestre',
      validar_datos_vivienda: 'Validate Associate Data',
      datos_vivienda: 'Club Data',
      datos_residente_principal: 'Associate Information',
      datos_residentes: 'Dependents Data',
      detalle_residente: 'Dependent Details',
      msg_reconoce_residentes: 'Do you recognize the Associate?',
      continuar: 'Continue',
      paso: 'Step',
      acciones: 'Actions',
      configuracion: 'Settings',
      host_photo: 'Host photo',
      casas: 'Number of actions',
      accion: 'Number of action',
      who_authorized: 'Who authorized?',
      residente_principal: 'Associate',
      residentes: 'Dependents',
      residente: 'Dependent',
      main_residents: 'Associates',
      msg_eliminar_registros: 'Are you sure to delete the selected record (s)?',
      msg_eliminar_casa: 'Are you sure to remove the action number?',
      msg_delete_lot: 'Are you sure to remove the Lot?',
      msg_eliminar_directory: 'Are you sure to remove the Record?',
      msg_delete_court: 'Are you sure to remove the Court?',
      msg_delete_schedule: 'Are you sure to remove this Schedule?',
      msg_delete_notice: 'Are you sure to remove the Notice?',
      msg_delete_financial_statements: 'Are you sure to remove the financial statements?',
      msg_delete_report: 'Are you sure to remove the Report?',
      msg_eliminar_caseta: 'Are you sure to remove the Guard House?',
      msg_delete_manager: 'Are you sure to remove the Manager?',
      msg_delete_guard: 'Are you sure to remove the Guard?',
      msg_delete_resident: 'Are you sure to remove the Dependent?',
      msg_delete_worker: 'Are you sure to remove the Worker?',
      msg_delete_main_resident: 'Are you sure to remove the Associate?',
      msg_enable_main_resident: 'Are you sure to enable the Associate?',
      msg_disable_main_resident: 'Are you sure to disable the Associate?',
      msg_accion_deshacer: 'This action cannot be undone.',
      codigo_pais: 'Country Code',
      ejemplo: 'Example: ',
      cellphone_wrong: 'Wrong Cellphone Number.',
      msg_usuario_sin_permisos: 'User without permissions, contact the Manager.',
      msg_vigilant_sin_permisos: 'Guard without permissions, contact the Manager.',
      msg_user_delete: 'User Removed Successfully.',
      msg_user_invalidate: 'The guest has been notified to correct their data.',
      initialDate: 'Initial date',
      finalDate: 'Final date',
      add_guest: 'Add Guest',
      access_without_code: 'Access without Code',
      select_video_device: 'Select Video Device',
      start_camera: 'Start camera',
      stop_camera: 'Stop camera',
      capture_photo: 'Capture photo',
      notificaciones: 'Notifications',
      canSendEmail: 'Do you want to receive emails?',
      canSendSMS: 'Do you want to receive SMS?',
      notificacion_success: 'Settings Updated Successfully.',
      rulebook_uploaded_successfully: 'Reglamento subido correctamente.',
      msg_offline: 'There is no Internet Conection!',
      access_success: 'Access Registered Successfully.',
      msg_exit_time_registered: 'Exit Time Registered Successfully.',
      msg_captura_foto: 'Click on the video to capture the image.',
      search_by_number_street_phone: 'Search by street/house number/phone',
      search_by_number_street: 'Search by street or house number',
      search_by_street: 'Search by street',
      search_by_house_number: 'Search by Action Number',
      search_by_street_house_number: 'Search by Street/Action Number',
      search_by_house_number_resident: 'Search by Street/Action Number/Dependent Name',
      search_by_house_street_resident: 'Search by Street/Dependent Name',
      search_by_name: 'Search by Name',
      service_catalog: 'Service Catalog',
      search_by_name_visitor: 'Search by Notes or Guest Name',
      search_by_address_notes_name_guest: 'Search by Address/Notes/Visitor Name',
      unique_resident: 'I don\'t have dependents',
      msg_signup_apartment: 'To start the Registration Process, it is necessary to Register the Associate.',
      place_holder_housing_units: 'Search by name',
      validado: 'Validated',
      validar: 'Validate',
      msg_confirma_validacion_1: 'You must select ',
      or: 'or',
      msg_confirma_validacion_2: 'to continue.',
      habitada: 'Inhabited',
      deshabitada: 'Uninhabited',
      cambiar_wallpaper: 'Change wallpaper',
      cambiar_wallpaper_exito: 'Image Changed Successfully.',
      activar_desactivar: 'Enable/Disable',
      activar: 'Enable',
      desactivar: 'Disable',
      note_disable_main_resident: 'Note: By deactivating the Associate, he and the dependents he registered will not be able to send invitations.',
      note_enable_main_resident: 'Note: By activating the Associate, the Associate and registered dependents will be able to send invitations.',
      servicio_suspendido: 'Suspended Service.',
      msg_supendido: 'This message is displayed for any of the following 2 reasons:',
      msg_supendido1: 'Because you do not have permission to send invitations or',
      msg_supendido2: 'Due to non-payment, the invitation service has been suspended',
      msg_supendido3: 'For more information, contact your Associate or Club Manager.',
      importar_casas: 'Import Number of actions',
      importar: 'Import',
      selecciona_archivo: 'Pick a Excel file.',
      selecciona_archivo_pdf: 'Pick a PDF file.',
      archivo: 'File',
      importar_casas_archivo: 'Import actions number from Excel file.',
      import_account_statements_file: 'Import account statements from excel file.',
      msg_importar_casas: 'Note: The file to import actions number must comply with the following format.',
      mostrar_formato: 'Show format',
      msg_mi_codigo: 'My Access Code',
      descargar: 'Download',
      renovar_codigos: 'Update QR codes',
      renovar_codigos_residentes: 'Update QR codes of Associates',
      msg_update_code_1: 'Allow Monthly update of Associates QR Codes automatically.',
      msg_update_code_2: 'Note: This update takes place on the first day of each month at 3:00 AM.',
      allow: 'Allow',
      cambios_aplicados: 'Changes Successfully Applied',
      label: 'Label',
      classification: 'Classification',
      device: 'Device',
      no_devices: 'No Devices',
      no_lots: 'No registered lots .',
      add_device: 'Add Device',
      device_added_successfully: 'Device added successfully.',
      device_modified_successfully: 'Device Modified successfully.',
      device_removed_successfully: 'Device removed successfully.',
      lot_removed_successfully: 'Lot removed successfully.',
      device_by_guardhouse: 'Device(s) by Guardhouse',
      delete: 'Delete',
      change: 'Change',
      show_devices: 'Show Device(s)',
      show_lots: 'Show Lots',
      show_details: 'Show details',
      msg_info_details: 'This information is only visible to the Administrator.',
      details: 'Details',
      lanesQR: 'Lanes with QR Reader',
      lanesCam: 'Lanes with Camera',
      devices: 'Devices',
      grados: 'Degrees',
      msg_can_not_delete_house01: 'It is not possible to delete the House.',
      msg_can_not_delete_house02: 'Currently one or more Associate are occupying it. Eliminate the Associate first.',
      no_records_yet: 'No records yet.',
      canceled_invitation: 'CANCELED INVITATION!',
      msg_canceled_invitation_offline: 'This invitation has been canceled by the Host.',
      msg_canceled_invitation: 'ACCESS DENIED! This invitation has been canceled by the Host.',
      msg_vacation_mode_activate: 'ACCESS DENIED! At the moment the house is not receiving visitors.',
      msg_out_date: 'ACCESS DENIED! This invitation is out of date or has expired.',
      msg_out_date2: 'ACCESS DENIED!. This invitation has expired.',
      msg_out_date3: 'ACCESS DENIED!. Entry is not authorized for this day.',
      msg_out_date_worker0: 'ACCESS DENIED!. This worker is not authorized entry for this day.',
      msg_out_date_worker1: 'ACCESS DENIED!. The deadline to access this worker has expired.',
      export_to_pdf: 'Export to PDF',
      access_report_no_code: 'Access report no code',
      period: 'Period: ',
      page: 'Page ',
      al: ' to ',
      de: ' of ',
      allow_device: 'Allow device',
      show_current_invitations: 'Show current invitations',
      msg_allow_device: 'Do you want the Vigilante to log in from this Browser?',
      show_house_phones: 'Show house phones',
      msg_allow_show_house_phones: 'Do you want the Watchers to be able to see the house phones?',
      msg_allow_show_current_invitations: 'Do you want the Watchers to be able to see the current invitations of the day?',
      msg_enable_ine_photo: 'What photo of the host do you want the guard to show when displaying the invitation information?',
      info_enable_ine_photo: 'Note: By activating this option, the guards will be able to see the ID of the guest, so the treatment given to the information presented is the responsibility of the client.',
      booth_registration: 'Booth registration',
      notice: 'Notice',
      title: 'Title',
      comments: 'Comments',
      no_comment: 'No Comments',
      administrator_comments: 'Administrator comments',
      file: 'File',
      msg_overflow_file: 'File size should be less than 2 MB!',
      type_reports: 'Type of reports',
      type_notices: 'Type of Notices',
      choose_category: 'Choose a category',
      evidence: 'Evidence',
      msg_evidence: 'If you want to add a photo as evidence, check the Add File box and then select the photo.',
      no_vidence: 'No evidence attached.',
      send_approval_request: 'Send approval request',
      approve: 'Approve',
      reject: 'Reject',
      send_communications: 'Send communications',
      send_communication_selected_owners: 'Send communication to selected owners',
      send_communication_owners: 'Send communication to owners',
      directory: 'Directory',
      show_vehicle_plates: 'Show vehicle plates',
      vehicle_plates: 'Vehicle plates',
      send_email_update: 'Send email, data validation/update',
      hide_video: 'Hide video',
      show_video: 'Show video',
      show_qr_code: 'Show QR code',
      display_info_print: 'Display information to print',
      generate_pdf_printing: 'Generate PDF for printing',
      number_cards_sheet: 'Number of cards per sheet',
      supplier: 'Supplier',
      q_supplier: 'Is a Supplier?',
      supplier_mode: 'Supplier mode: ',
      msg_supplier: 'This person has been invited in supplier mode, please carry out the security protocol for suppliers.',
      tooltip_supplier: 'If your visit is going to perform any service or delivery at your home, tell the subdivision to expedite their entry and that the security protocol for suppliers is carried out.',
      account_statements: 'Account statements',
      relate_home: 'Relate home',
      vacation_mode: 'Vacation Mode: ',
      msg_vacation_mode: 'At the moment the house is not receiving visitors.',
      allow_access_visitors: 'Allow access to visitors',
      allow_access_residents: 'Allow access to dependents',
      allow_access_workers: 'Allow access workers',
      rulebook: 'Rulebook',
      guardhouse_name_checkin: 'Guardhouse Check-In',
      guardhouse_name_checkout: 'Guardhouse Check-Out',
      current_invitations: 'Current invitations',
      data_correction_form: 'Data correction form',
      data_correction: 'Data correction',
      msg_photograph_blurred: 'Official identification photograph is indistinguishable (blurred)',
      send_correction_request: 'Send correction request',
      data_correction_sent: 'Data correction sent.',
      additional_comments: 'Additional comments',
      msg_additional_comments: 'Write additional comments. \nNote: these comments will be attached to the email.',
      additional_person: 'Additional person',
      msg_additional_person: 'The guest comes with more people',
      show_additional_people: 'Show additional people',
      additional_people: 'Additional people',
      show_all_residents: 'Show all',
      show_secondary_residents: 'Show Dependents',
      msg_no_registered_secondary_residents_yet: 'This Associate has not registered dependents yet.',
      register: 'Register',
      register_parcel: 'Register parcel',
      addressee: 'Addressee',
      guide_number: 'Guide number',
      company: 'Company',
      who_delivered: 'Who delivered?',
      who_received: 'Who received?',
      package_delivery: 'Package delivery',
      parcel: 'Parcel',
      date_time_receipt: 'Date time receipt',
      delivery_date_time: 'Delivery date time',
      in_booth: 'In booth',
      delivered: 'Delivered',
      payroll_number: 'Payroll number',
      position: 'Position',
      instructor_name: 'Instructor name',
      description: 'Description',
      import_titulars: 'Import titular',
      titulars_imported_correctly: 'Titulars imported successfully.',
      booking: 'Booking',
      create_booking: 'Create booking',
      reservation_created_successfully: 'Reservation created successfully.',
      confirm_booking: 'Confirm booking',
      reservation_confirmed_successfully: 'Reservation confirmed successfully.',
      reject_reservation: 'Reject reservation',
      reservation_successfully_rejected: 'Reservation successfully rejected.',
      cancel_reservation: 'Cancel reservation',
      reservation_successfully_canceled: 'Reservation successfully canceled.',
      courts: 'Courts',
      choose_court: 'Choose a court',
      choose_owner: 'Choose owner',
      booking_created_by: 'Booking created by:',
      booking_in_name_of: 'Reservation in the name of:',
      error_msg_0: 'Reservations must be made at least 30 minutes in advance.',
      reservation_time: 'Reservation time',
      choose_time: 'Choose time',
      choose_type: 'Choose type',
      choose_motive: 'Choose motive',
      court_created_successfully: 'Court created successfully.',
      court_updated_successfully: 'Court updated successfully.',
      court_deleted_successfully: 'Court removed successfully.',
      msg_warning_court: 'Deleting this court will also delete all reservations for it.',
      open: 'Open',
      closed_due_to_rain: 'Closed due to rain',
      closed_due_to_lightning_storm: 'Closed due to lightning storm',
      open_with_damaged_greens: 'Open with damaged greens',
      close_court: 'Close court',
      open_court: 'Open court',
      motive: 'Motive',
      closing_start_date_time: 'Closing start',
      closing_end_date_time: 'Closing end',
      court_closed_successfully: 'Court closed successfully',
      hole: 'Hole',
      holes: 'Holes',
      reservation_details: 'Reservation Details',
      date: 'Date',
      time: 'Time',
      // Golf Module
      golf_courts: 'Golf Courses',
      add_golf_court: 'Add Tee Time',
      golf_court_name: 'Tee Time Name',
      golf_court_type: 'Tee Time Type',
      total_holes: 'Total Holes',
      hole_range_start: 'Start Hole',
      hole_range_end: 'End Hole',
      minutes_per_hole: 'Minutes per Hole',
      time_interval: 'Time Interval (min)',
      opening_days: 'Opening Days',
      golf_court_details: 'Tee Time Details',
      hole_range: 'Hole Range',
      days_open: 'Days Open',
      delete_golf_court_confirm: 'Are you sure you want to delete this golf course? This action cannot be undone.',
      delete_golf_court_title: 'Delete Course?',
      standard: 'Standard',
      professional: 'Professional',
      practice: 'Practice',
      dom: 'Sun',
      lun: 'Mon',
      mar: 'Tue',
      mie: 'Wed',
      jue: 'Thu',
      vie: 'Fri',
      sab: 'Sat',
      new_golf_court: 'New Course',
      edit_golf_court: 'Edit Course',
      view_details: 'View Details',
      edit: 'Edit',
      delete_action: 'Delete',
      active: 'Active',
      inactive: 'Inactive',
      required_field: 'This field is required.',
      positive_number_error: 'Must be a positive number.',
      // Golf Reservations
      golf_reservations: 'Golf Reservations',
      new_reservation: 'New Reservation',
      edit_reservation: 'Edit Reservation',
      reservation_date: 'Date',
      golf_court: 'Court',
      holder: 'Holder',
      caddie: 'Caddie',
      players: 'Players',
      player_names: 'Player Names',
      confirm_cancel_reservation: 'Are you sure you want to cancel this reservation?',
      reservation_status: 'Status',
      pending: 'Pending',
      reservations_for: 'Reservations for',
      no_reservations_for_date: 'No reservations for this date',
      start_hole: 'Start Hole',
      hole_count: 'Hole Count',
      press_enter_to_add_names: 'Press Enter to add names',
      reservation_cancelled_success: 'Reservation cancelled successfully',
      error_fetching_reservations: 'Error fetching reservations',
      error_cancelling_reservation: 'Error cancelling reservation',
      reservation_updated_success: 'Reservation updated successfully',
      reservation_created_success: 'Reservation created successfully',
      error_saving_reservation: 'Error saving reservation',
      status_updated_success: 'Status updated successfully',
      error_updating_status: 'Error updating status',
      requests: 'Requests',
      cancellations: 'Cancellations',
      calendar_view: 'Calendar',
      accept_cancellation: 'Accept Cancellation',
      reject_cancellation: 'Reject Cancellation',
      confirm_reservation: 'Confirm Reservation',
      is_recurring: 'Is recurring',
      end_date: 'End date',
      days_of_week: 'Days of week',
      recurring_reservations_created_success: 'Recurring reservations created successfully',
      guest: 'Guest',
      guest_name: 'Guest Name',
      caddies: 'Caddies',
      others: 'others',
      user: 'User',
      add_player: 'Add Player',
      // Golf Blacklist
      golf_blacklist: 'Golf Blacklist',
      add_to_blacklist: 'Add to Blacklist',
      reason: 'Reason',
      unlock_date: 'Unlock Date',
      blocked_user: 'Blocked User',
      remove_from_blacklist: 'Remove from Blacklist',
      confirm_remove_blacklist: 'Are you sure you want to unblock this user?',
      permanent: 'Permanent',
      caddie_created_success: 'Caddie created successfully',
      caddie_updated_success: 'Caddie updated successfully',
      caddie_deleted_success: 'Caddie deleted successfully',
      // Golf Dashboard
      golf_administration: 'Golf Administration',
      select_option_admin: 'Select an option to manage',
      manage_golf_course: 'Manage golf course',
      manage_reservations: 'Manage user reservations',
      manage_blacklist: 'Manage user blacklist',
      // Golf Court Statuses
      court_status_open: 'Open',
      court_status_rain: 'Closed due to rain',
      court_status_storm: 'Closed due to lightning storm',
      court_status_minor_damage: 'Open with minor damage',
      court_status_damaged_greens: 'Open with damaged greens',
      court_status_maintenance: 'Closed for maintenance',
      // Blacklist additional translations
      permanent_hint: 'Leave empty for permanent ban',
      error_fetching_users: 'Error fetching users',
      error_fetching_blacklist: 'Error fetching blacklist',
      removed_from_blacklist_success: 'User unbanned successfully',
      error_removing_blacklist: 'Error unbanning user',
      blacklist_updated_success: 'Blacklist updated successfully',
      added_to_blacklist_success: 'User added to blacklist successfully',
      error_saving_blacklist: 'Error saving to blacklist',
      no_users_found: 'No users found',
      restricted_until: 'Restricted until',
      mark_as_no_show: 'Mark as No Show',
      confirm_no_show: 'Are you sure you want to mark this reservation as No Show? A strike will be added to the user.',
      no_show_success: 'Reservation marked as No Show and a strike was added to the user.',
      error_marking_no_show: 'Error marking as No Show',
      strikes: 'Strikes',
      automatic_strike_system: 'Automatic Strike System',
      reset_strikes: 'Reset Strikes',
      confirm_reset_strikes: 'Are you sure you want to reset strikes for this user?',
      reset_strikes_info: 'This will set strikes to 0 and deactivate the blacklist entry.',
      strikes_reset_success: 'Strikes reset successfully',
      error_resetting_strikes: 'Error resetting strikes',
      unban_info: 'This will deactivate the blacklist entry but keep the strike history.',
      banned: 'Banned',
      // Golf Caddies
      golf_caddies: 'Caddies',
      add_caddie: 'Add Caddie',
      caddie_name: 'Caddie Name',
      caddie_details: 'Caddie Details',
      new_caddie: 'New Caddie',
      edit_caddie: 'Edit Caddie',
      delete_caddie_title: 'Delete Caddie?',
      delete_caddie_confirm: 'Are you sure you want to delete this caddie? This action cannot be undone.',
      manage_caddies: 'Manage golf course caddies'
    }
  }
})
